module.exports = __webpack_public_path__ + "img/8.6702d9b6.png";